import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TipoDocumento} from '../../../models/tipo-documento';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {NewFile} from '../new-file';
import {BehaviorSubject, combineLatest, Observable, Subject, Subscription} from 'rxjs';
import {debounceTime, map, shareReplay, tap, withLatestFrom} from 'rxjs/operators';
import {TipologicaDTO} from '../../../models/tipologica-d-t-o';
import {MessageService} from '../../../services/message.service';
import {ValidationService} from "../../../services/validation.service";
import {InfoTipService} from '../../../../info-tip/info-tip.service';


@Component({
	selector: 'lib-carica-documenti',
	templateUrl: './carica-documenti.component.html',
	styleUrls: ['./carica-documenti.component.css']
})
export class CaricaDocumentiComponent implements OnInit {

	@Input()
	tipologieDocumento: Array<TipologicaDTO>;

	@Input()
	tipologieEmittente: Array<TipologicaDTO>;

	@Input()
	tipologieTipiEmittenti$: Observable<Array<TipologicaDTO>>;

	form: FormGroup;

	@Output()
	onFileAdded: EventEmitter<NewFile> = new EventEmitter();

	@ViewChild('fileInput')
	fileInput: ElementRef;
	maxDate = new Date();

	/* Stream campi input */
	tipoDocumento$: Observable<TipoDocumento>;
	soggettoEmittente$: Observable<string>;
	dataDocumento$: Observable<Date>;
	numeroDocumento$: Observable<string>;
	note$: Subject<string>;
	tipologieEmittente$: Subject<TipologicaDTO>;
	validitaForm$: Subject<boolean> = new Subject<boolean>();
	nameFileTruncated: string;

	/* Stream files caricati */
	files$ = new BehaviorSubject<File>(null);

	/* Stream click bottone aggiungi files */
	addFiles$: Subject<any>;

	subscription: Subscription;

	numeroDocumentoCaption: string;


	constructor(public msg: MessageService, private infoTipService: InfoTipService) { }

	ngOnInit() {
		// //TODO
		// if (!this.tipologieEmittente) {
		// 	this.tipologieEmittente = [{ codice: "TIPOLOGIE_EMITTENTE_1", descrizione: "tipologieEmittente1", id: "1", codiceLingua: "it_IT" }]
		// }
		this.form = new FormGroup({});
		const tipoDocumento = new FormControl({ value: null, disabled: false }, [Validators.required]);
		const soggettoEmittente = new FormControl({ value: "", disabled: false }, [Validators.required]);
		const dataDocumento = new FormControl({ value: "", disabled: false }, [Validators.required, ValidationService.ValidateDate]);
		const numeroDocumento = new FormControl({ value: "", disabled: false }, [Validators.required]);
		const tipologiaEmittente = new FormControl({ value: null, disabled: false }, []);
		const note = new FormControl({ value: "", disabled: false }, []);

		this.form.addControl('tipoDocumento', tipoDocumento);
		this.form.addControl('soggettoEmittente', soggettoEmittente);
		this.form.addControl('dataDocumento', dataDocumento);
		this.form.addControl('numeroDocumento', numeroDocumento);
		this.form.addControl('tipologiaEmittente', tipologiaEmittente);
		this.form.addControl('note', note);

		this.tipoDocumento$ = tipoDocumento.valueChanges.pipe(shareReplay());
		this.soggettoEmittente$ = soggettoEmittente.valueChanges.pipe(shareReplay());
		this.dataDocumento$ = dataDocumento.valueChanges.pipe(shareReplay());

		this.numeroDocumento$ = numeroDocumento.valueChanges
			.pipe(debounceTime(800), shareReplay());

		this.addFiles$ = new Subject<any>();

		this.note$ = new Subject<string>();
		this.tipologieEmittente$ = new Subject<TipologicaDTO>();


		const dtos$: Observable<NewFile> = combineLatest(
			[this.tipoDocumento$, this.files$, this.soggettoEmittente$, this.dataDocumento$, this.numeroDocumento$, this.tipologieEmittente$, this.note$])
			.pipe(
				map(([tipDocumento, file, soggettoEmittente, dataDocumento, numeroDocumento, codiceTipoEmittente, nota]) => {
					return new NewFile(
						new Date().getTime().toString(),
						file as File,
						tipDocumento as TipoDocumento,
						soggettoEmittente as string,
						dataDocumento as Date,
						numeroDocumento as string,
						codiceTipoEmittente as string,
						nota as string);
				})
			);

		this.addFiles$.pipe(
			debounceTime(300),
			withLatestFrom(dtos$),
			tap(([_, dto]) => {
				this.onFileAdded.emit(dto);
				this.validitaForm$.next(true);
				this.pulisciForm();
			})
		).subscribe();

		this.infoTipService.getInfo$('numero-documento').subscribe(info => {
			this.numeroDocumentoCaption = info.tooltip;
		});
	}

	sfoglia(_) {
		if (this.fileInput.nativeElement) {
			this.fileInput.nativeElement.click();
		}
	}

	filesChanged() {
		const file: File = this.fileInput.nativeElement.files[0];
		this.files$.next(file);
		this.nameFileTruncated = this.formatFunction(file.name);

	}

	aggiungiFile(event) {
		this.tipologieEmittente$.next(this.form.value["tipologiaEmittente"]);
		this.note$.next(this.form.value["note"]);
		this.addFiles$.next(event);
		this.fileInput.nativeElement.value = '';
		//this.form.reset();
	}

	public resetForm() {
		this.form.reset();
	}

	ngOnDistory() {
		this.subscription.unsubscribe()
	}

	formatFunction(nomeFile: string): string {
		return nomeFile.length > 18 ? nomeFile.substring(0, 18) + '...' + nomeFile.substring(nomeFile.length, nomeFile.length - 4) : nomeFile
	}

	pulisciForm() {
		Object.keys(this.form.value)
			.forEach(campo => {
				this.form.get(campo).setValue('')
			});
		this.files$.next(null);
	}
}
